import { Box, TextField, Button, DialogActions } from "@mui/material";
import Messages from "../../../localization/Messages";
import { useIntl } from "react-intl";
import { Save } from "@mui/icons-material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useSidebarOwner } from "../../../contexts/SidebarOwnerContext";
import { IShipDispatcher } from "../../../models/shipDispatcher";
import { updateDockAccess } from "../../../api/ship";
import { showBackendMessage } from "../../../helpers/messagesHelper";

export type ShipRemarkDialogProps = {
    onClose: () => void;
    onSubmit?: () => Promise<void>;
    field: "remarks" | "remarksTechnical";
};

export function ShipRemarkDialog({
    onClose,
    onSubmit = async () => {},
    field,
}: ShipRemarkDialogProps) {
    const [ship, setShip] = useSidebarOwner<IShipDispatcher>();
    const intl = useIntl();
    const dispatch = useDispatch();
    const [remark, setRemark] = useState(
        field === "remarks" ? ship?.remarks : ship?.remarksTechnical,
    );
    const [loading, setLoading] = useState(false);

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRemark(event.target.value ?? "");
    };

    const onRemarkSave = async () => {
        setLoading(true);
        try {
            if (ship) {
                const updated: IShipDispatcher = { ...ship, [field]: remark ?? "" } as any;
                await updateDockAccess(updated);
                // update locally as API returns IShip which doesn't include dispatcher fields
                setShip(updated);
                dispatch(showBackendMessage(intl, "success", "updating", Messages.ship));
            }
            onClose();
            await onSubmit();
        } catch {
            dispatch(showBackendMessage(intl, "error", "updating", Messages.ship));
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Box display="flex" marginY={1} marginRight={1}>
                <TextField
                    multiline
                    rows={10}
                    autoFocus
                    fullWidth
                    value={remark ?? ""}
                    label={
                        field === "remarks"
                            ? intl.formatMessage(Messages.remarksFgksDispatcher)
                            : intl.formatMessage(Messages.remarksTechnicalInformation)
                    }
                    onChange={onChange}
                    variant="outlined"
                />
            </Box>

            <DialogActions>
                <Button variant="outlined" onClick={onClose}>
                    {intl.formatMessage(Messages.cancel)}
                </Button>
                <Button
                    variant="contained"
                    onClick={onRemarkSave}
                    disabled={loading}
                    color="success"
                    startIcon={<Save />}
                >
                    {intl.formatMessage(Messages.save)}
                </Button>
            </DialogActions>
        </>
    );
}

export default ShipRemarkDialog;
